module.exports = __webpack_public_path__ + "img/vue-03-02.ae25f418.png";